import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Params } from '@angular/router';
import { routerTransition } from "../animations";
import { Subscription } from 'rxjs';
import { QuibblTreeComponent } from './quibbl-tree/quibbl-tree.component';

@Component({
  selector: 'category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss'],
  animations: [routerTransition()],
  host: {'[@routerTransition]': '', '(window:scroll)': 'onScroll($event)'}
})
export class CategoryComponent implements OnInit {

  public initialState: boolean = true;
  public currentCategory: string;

  public routerSubscription: Subscription;
  public categorySubscription: Subscription;

  @ViewChild('treeContainer') private scrollContainer: ElementRef;
  @ViewChild('quibblTree') private quibblTree: QuibblTreeComponent;

  constructor(private router: Router,
              private route: ActivatedRoute) {
                this.initialState = route.children.length == 0;
              }

  ngOnInit() {
    // Grab category from params
    this.categorySubscription = this.route.params.subscribe(params => {
      this.currentCategory = params['categoryId'];

      // Scroll to top
      try {
        //console.log(window.innerWidth);
        if(window.innerWidth > 768) {
          this.scrollContainer.nativeElement.scrollTop = 0;
          //console.log("scrolling div");
        }
        else {
          window.scrollTo(0,0);
          //console.log("scrolling window");
        }
      } catch(err) {
        //console.log(err)
      }
    });

    // Subscribe to child route changes so we're notified when we move to detail
    this.routerSubscription = this.router.events
    .filter(event => event instanceof NavigationEnd)
    .subscribe((event:NavigationEnd) => {
      this.initialState = this.route.children.length==0;
    });
  }

  ngOnDestroy() {
    if(this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }

    if(this.categorySubscription) {
      this.categorySubscription.unsubscribe();
    }
  }

  onScroll(event) {
    let offset = (event.target.scrollHeight) ? event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight
                                             : event.target.scrollingElement.scrollHeight - event.target.scrollingElement.scrollTop - event.target.defaultView.innerHeight;
    //console.log(offset);
    if(offset < 200) {
      this.quibblTree.fetchMoreQuibbls();
    }
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/category/category.component.ts